import React, {Component} from 'react';
import lookups from '../lookups.json'; //lookup tables for all the possible choices
import './Dialogs.min.css';

export class PrintDialog extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        //var uuid = generateUUID();
        var uuid = "MTS_Actuator_Design_" + new Date().getTime().toString().slice(6); //create unique name
        console.log("first =" + url)

        //update iframe url
        var url = this.props.urlDW2 + "/Integration?run=MTS_244_Sales&Transition=Print&PdfName=" + uuid;
        console.log("first =" + url)
        var customer = [];
        customer.push("CustFirstName=" + this.props.customer.firstName);
        customer.push("CustLastName=" + this.props.customer.lastName);
        customer.push("CustEmail=" + this.props.customer.email);
        customer.push("CustCompany=" + this.props.customer.company);
        customer.push("CustPhone=" + this.props.customer.phone);
        customer.push("CustCountry=" + this.props.customer.country);
        customer.push("CustProject=" + this.props.customer.projectName);
        url+= "&" + customer.join("&");

        for(var i = 0; i < this.props.data.parameters.length; i++){
            url+= "&" + this.props.data.parameters[i].dwVar + "=" + (parseInt(this.props.data.parameters[i].choice)); 
        }
        var iframe = document.querySelector("#test_iframe");
        iframe.src = url //send current setup to second iframe tied to another instance of the DW stuff
        console.log("sent = " + url);

        //call pdfwatcher webservice to watch for the new 'guid'.pdf file
        let params = {"guid": uuid};
        let query = Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&'); //encode the querystring parameters
        let pdf_url = this.props.urlSite + '/pdfwatcher/server.js?' + query;

        var width = 600;
        var height = 750;
        var leftPos = (window.screen.width / 2) - 251;
        var topPos = (window.screen.height *.1);
        var popup = window.open("print.html", "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,width=" + width + ",height=" + height + ",top=" + topPos + ",left=" + leftPos);

        fetch(pdf_url)
        .then(response => response.json())
        .then(data => handleGuid(data, popup, this)) //pass showPopup function along to avoid scope issues
        .catch(error => handleError(error, popup, this)); //pass scope along with error

        function handleGuid(guid, popup, scope){
            var width = 600;
            var height = 750;
            var leftPos = (window.screen.width / 2) - 251;
            var topPos = (window.screen.height *.1);
            scope.props.onClick(null);
            popup.location.href= scope.props.urlSite + "/pdfwatcher/pdfs/" + guid.guid + ".pdf";
        }

        function handleError(error, popup, scope){
            scope.props.onClick('print_error');
            popup.close();
            console.log('error is ' + error);
        }

        function generateUUID() { // Public Domain/MIT
            var d = new Date().getTime();
            if (typeof performance !== 'undefined' && typeof performance.now === 'function'){
                d += performance.now(); //use high-precision timer if available
            }
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
        }
        return (
            //<div id="dlg_print" style={{padding:"0.5em", display: "none"}}>Creating Print PDF</div>
            <div id="dlg_print" className="dialog">
            </div>
        );
    }
}

export class PrintErrorDialog extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div id="dlg_print_error" className="dialog">
                <div className="dlg_modal">
                    <div className="dlg_title">
                        <img src="images/mtsLogo.png"/>
                        <div className="dlg_title_txt">Printing Error</div>
                        <div className="dlg_exit" onClick={() => this.props.onClick(null, false)}>X</div>
                    </div>
                    <div className="dlg_content">
                        <div className="dlg_white">
                            <div className="dlg_spinner_container">
                                <img className="dlg_spinner" src="images/exclamation.jpg" />
                                <span className="dlg_spin_head">System Error - please try again later</span>
                            </div>
                        </div>
                        <div id="dlg_print_error_btn" className="dlg_btn" onClick={() => this.props.onClick(null)}>CLOSE</div>
                    </div>
                </div>
            </div>
        );
    }
}

export class PrintDialog_Test extends Component {
    constructor(props) {
        super(props);
    }
    render() {

        //var iframe = document.querySelector("#dwIframe");
        //var innerDoc = iframe.contentDocument || iframe.contentWindow.document;
        //var canvas = innerDoc.querySelector("canvas");
        //console.log(canvas);

        var url = [];
        url.push("print.html?at=" + this.props.at);
        //get titles for all the option choices
        for(var i = 0; i < this.props.data.parameters.length; i++){
            var choices=[];
            var choice = this.props.data.parameters[i].choice;
            var arrChoices = this.props.data.parameters[i].choices.split(",");
            if(arrChoices[0] == "all"){
                choices = lookups.options[i].choices;
            }else{
                for(var j = 0; j < arrChoices.length; j++){
                    choices.push(lookups.options[i].choices[arrChoices[j]]);
                }
            }
            url.push(this.props.data.parameters[i].saveVar + "=" + choices[choice].title);
            url.push(this.props.data.parameters[i].saveVar + "=" + choice);
        }
        url.push("cf=" + this.props.customer.firstName);
        url.push("cl=" + this.props.customer.lastName);
        url.push("ce=" + this.props.customer.email);
        url.push("cc=" + this.props.customer.company);
        url.push("cp=" + this.props.customer.phone);
        url.push("cy=" + this.props.customer.country);
        url.push("cn=" + this.props.customer.projectName);
        url.push("dwUrl=http://dw.3dstudio-dev.mts.com/Integration?run=MTS_244_Sales_UI");

        var width = 600;
        var height = 750;
        var leftPos = (window.screen.width / 2) - 251;
        var topPos = (window.screen.height *.1);
        var popup = window.open(url.join("&"), "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,width=" + width + ",height=" + height + ",top=" + topPos + ",left=" + leftPos);

        return (
            <div style={{padding:"0.5em", display: "none"}}>Displaying Printout</div>
        );
    }
}
